<template>
  <a v-bind:href="printersUrl" target="_blank" rel="noopener">
      <LabelFunMessage fcontId="0" msgkey="29"/> &raquo;
  </a>
</template>

<script>
import LabelFunMessage from './LabelFunMessage'
import CompativlePrinter from '@/common/compatibleprinters.url';

export default {
  name: 'AppCompatiblePrinters',
  components: { LabelFunMessage },
  props: {
    appName: String
  },
  computed: {

    printersUrl : function () {
      return CompativlePrinter.printerlistURL(this.appName, this.$store.state.lg2);
    },

    articleId: function() {
      return this.$route.path.match(/\/\d+/).shift().slice(1);
    }

  },
  methods: {
  }
}
</script>

<style scoped>
/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  a {
    font-size: 12px;
  }
}
</style>
